<template>
  <div class="login-shell">
    <div class="top-bar">
      <div class="nav-logo" @click="goHome">
        <div class="logo-mark">Z</div>
        <span class="logo-text">智磐 AI</span>
      </div>
      <div class="badge">跨境电商AI生产力平台</div>
    </div>

    <div class="login-layout">
      <section class="hero-pane">
        <div class="hero-copy">
          <h1>跨境电商，就用智磐</h1>
          <p>
            统一串联商品抠图、宣传图、短视频与文案生成，
            让跨境电商素材生产从“人力拼接”升级为“流程协同”。
          </p>
        </div>

        <div class="preview-card">
          <div class="preview-toolbar">
            <span class="dot red"></span>
            <span class="dot yellow"></span>
            <span class="dot green"></span>
          </div>
          <div class="preview-body">
            <div class="preview-line long"></div>
            <div class="preview-line mid"></div>
            <div class="preview-grid">
              <span v-for="item in 8" :key="item" class="preview-tile"></span>
            </div>
          </div>
        </div>
      </section>

      <section class="form-pane">
        <LoginForm />
      </section>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import LoginForm from "@/components/login/LoginForm.vue";

const router = useRouter();
const goHome = () => router.push("/home");
</script>

<style scoped>
.login-shell {
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system,
    BlinkMacSystemFont, sans-serif;
  background: #f8f2ea;
  background-image: radial-gradient(at 0% 0%, #f5e7d8 0px, transparent 56%),
    radial-gradient(at 100% 0%, #f9ecdf 0px, transparent 56%),
    radial-gradient(at 100% 100%, #f0dfcf 0px, transparent 58%),
    radial-gradient(at 0% 100%, #fcf7f0 0px, transparent 54%);
}

.login-layout {
  width: min(1120px, 100%);
  display: grid;
  grid-template-columns: 1.15fr 0.95fr;
  gap: 2rem;
  align-items: center;
}

.hero-pane {
  padding: 1rem 0.6rem;
}

.top-bar {
  position: absolute;
  top: 2rem;
  left: 2rem;
  right: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
}

.nav-logo {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.logo-mark {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #1a1a1a;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
}

.logo-text {
  font-weight: 600;
  font-size: 1.1rem;
  color: #1f1f1f;
}

.hero-copy h1 {
  margin: 1rem 0 0.8rem;
  font-size: 3rem;
  line-height: 1.3;
  color: #1f1f1f;
  letter-spacing: 0.03em;
}

.hero-copy p {
  margin: 0;
  max-width: 520px;
  color: #61584f;
  font-size: 1rem;
  line-height: 1.9;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.9rem;
  border-radius: 999px;
  background: rgba(201, 150, 88, 0.14);
  color: #c99658;
  font-size: 0.8rem;
  font-weight: 600;
}

.preview-card {
  margin-top: 1.7rem;
  max-width: 580px;
  border-radius: 20px;
  overflow: hidden;
  background: rgba(255, 253, 249, 0.94);
  border: 1px solid rgba(62, 47, 33, 0.1);
  box-shadow: 0 24px 48px -24px rgba(44, 33, 21, 0.32);
}

.preview-toolbar {
  height: 38px;
  background: #2f2a27;
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0 0.9rem;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.dot.red {
  background: #ff5f57;
}

.dot.yellow {
  background: #ffbd2e;
}

.dot.green {
  background: #28c840;
}

.preview-body {
  padding: 1.2rem;
  background: linear-gradient(145deg, #f7f0e8 0%, #f2e9df 100%);
}

.preview-line {
  height: 12px;
  border-radius: 999px;
  background: rgba(44, 33, 21, 0.12);
}

.preview-line.long {
  width: 72%;
}

.preview-line.mid {
  margin-top: 0.7rem;
  width: 56%;
}

.preview-grid {
  margin-top: 1.1rem;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.7rem;
}

.preview-tile {
  display: block;
  height: 64px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(62, 47, 33, 0.08);
}

.form-pane {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 1024px) {
  .login-layout {
    grid-template-columns: 1fr;
    gap: 1.4rem;
  }

  .hero-pane {
    padding: 0;
  }

  .hero-copy h1 {
    font-size: 2.3rem;
  }

  .preview-card {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .login-shell {
    padding: 1rem;
    min-height: 100dvh;
    align-items: flex-start;
    padding-top: 4rem;
    overflow-y: auto;
  }

  .top-bar {
    top: 1rem;
    left: 1rem;
    right: 1rem;
  }

  .login-layout {
    gap: 1rem;
  }

  .preview-card {
    display: none;
  }

  .hero-copy {
    text-align: center;
  }

  .hero-copy h1 {
    font-size: 1.95rem;
  }

  .hero-copy p {
    font-size: 0.95rem;
    line-height: 1.75;
    margin: 0 auto;
  }
}
</style>
